// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fe_f_all .TermsOfUse-module__emphasis--_Pba6{font-style:italic;font-weight:600}`, "",{"version":3,"sources":["webpack://./src/components/ui/TermsOfUse/TermsOfUse.module.scss"],"names":[],"mappings":"AACE,8CACE,iBAAA,CACA,eAAA","sourcesContent":[":global(.fe_f_all) {\n  .emphasis {\n    font-style: italic;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emphasis": `TermsOfUse-module__emphasis--_Pba6`
};
export default ___CSS_LOADER_EXPORT___;
